export const COMPANY = {
  name: "PIXAWEB Sagl",
  address: "Via Cantonale 19, 6900 Lugano, Svizzera",
  addressShort: "Via Cantonale 19, 6900 Lugano (CH)",
  notices: "Via Cantonale 19, 6900 Lugano (TI)",
  uid: "CHE-364.397.948",
  register: "CH-501.4.024.588-7",
  form: "Società a garanzia limitata (Sagl)",
  capital: "CHF 20.000,00",
  email: "legal@pixawebch.com",
  updated: "10 ottobre 2026",
};
